import React, { useContext } from "react";
import styles from "./styles.scss";
import { SubscriptionContext } from "src/services/SubscriptionService";

interface VibeTrialBlockProps {
  sport: string;
  source: string;
  game?: { id: string; homeTeam: { fullName: string }; awayTeam: { fullName: string } };
}

const VibeTrialBlock = (props: VibeTrialBlockProps & React.HTMLAttributes<HTMLDivElement>) => {
  const ctx = useContext(SubscriptionContext);

  const { sport, source, game, ...rest } = props;

  const handler = () =>
    ctx.togglePricingModal({
      track: {
        page: window.location.href,
        sport: sport,
        source: source,
        awayTeam: game?.awayTeam?.fullName,
        homeTeam: game?.homeTeam?.fullName,
        gameId: game?.id,
      },
      source: source,
    });

  return (
    <div className="betql-trial-wrap" {...rest}>
      <div className="betql-trial-badge">
        <div className="betql-trial-badge-days">3</div>
        <div className="betql-trial-badge-label">Days Free</div>
      </div>

      <div className="betql-trial-copy">
        <div className="betql-trial-eyebrow">Limited Offer</div>
        <p className="betql-trial-headline">
          Bet Smarter. Try BetQL Pro
          <br />
          Free for 3 Days.
        </p>
        <div className="betql-trial-perks">
          <span className="betql-trial-perk">AI-Powered Picks</span>
          <span className="betql-trial-perk">Sharp Money Alerts</span>
          <span className="betql-trial-perk">Live Line Movement</span>
          <span className="betql-trial-perk">Model Bets &amp; Trends</span>
        </div>
      </div>

      <div className="betql-trial-cta-block">
        <button className="betql-trial-btn" onClick={handler}>
          Start My Free Trial →
        </button>
        <div className="betql-trial-fine">
          <strong>Cancel anytime. Billed after trial ends.</strong>
        </div>
      </div>

      <style jsx>{styles}</style>
    </div>
  );
};

export default VibeTrialBlock;
